require('./myProfileSecurityKitChange.scss');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
// @ actions
const { changeKit } = require('actions/myProfileSecurityKitChange');
import { validateAndExecuteSagas } from 'actions/signaturePattern';
// @ commons
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
// @ components
import KitsSummary from 'components/myProfile/myProfileSecurityKitChange/kitsSummary/kitsSummary';
import ChangeSecurityKitStep from 'components/myProfile/myProfileSecurityKitChange/steps/changeSecurityKitStep';
// @ constants
const { SECURITY_KIT_CHANGE } = require('constants/operationTypes');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;

class MyProfileSecurityKitChange extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            defaultKit: props.immMyProfileSecurityKitChange.get('defaultKit'),
            referencePillButton: props.immMyProfileSecurityKitChange.get('referencePillButton'),
            referenceKits: props.immMyProfileSecurityKitChange.get('referenceKits'),
            sets: props.immMyProfileSecurityKitChange.get('sets'),
            nextButtonDisabledStep1: true,
        }
        this.setNode = this.setNode.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { immMyProfileSecurityKitChange } = nextProps;
        !this.props.immMyProfileSecurityKitChange.get('defaultKit') && this.setState({
            defaultKit: immMyProfileSecurityKitChange.get('defaultKit'),
            referencePillButton: immMyProfileSecurityKitChange.get('referencePillButton'),
            referenceKits: immMyProfileSecurityKitChange.get('referenceKits'),
            sets: immMyProfileSecurityKitChange.get('sets')
        })
    }

    setNode(ref) {
        this.nodeReference = ref;
    }

    onCancel = () => {
        this.props.onCancel();
    }

    changeKit = () => {
        const { defaultKit, sets } = this.state;
        const { changeKit, validateAndExecuteSagas } = this.props;
        validateAndExecuteSagas((dispatch, getState, dataToken) => {
            changeKit(defaultKit, sets, dataToken);
        })
    }

    handlerValidateStep() {
      const {
          validateStep,
      } = this.props;
      this.setState({
         sets: this.nodeReference.state.sets,
         defaultKit: this.nodeReference.state.defaultKit
       })
      validateStep()
    }

    renderWizard() {
        const {
            immMyProfileSecurityKitChange,
            isNerudaUser,
            setVisibleStep,
        } = this.props;
        const {
            sets,
            referenceKits,
            referencePillButton,
            defaultKit,
            nextButtonDisabledStep1
        } = this.state;

        const actions = {
            cancel: this.onCancel,
            finish: this.changeKit,
            setWillCancel: (() => {}),
            setVisibleStep,
            validateStep: () => this.handlerValidateStep(),
        };

        const immFinalButton = 'signatureEdit-change';
        const steps = immMyProfileSecurityKitChange.get('steps');
        const stepsAmount = steps.size;
        const visibleStep = immMyProfileSecurityKitChange.get('visibleStep');
        const wizardClass = 'my-profile-keys-signature__wizard';

        return (
            <Wizard
                wizardClass={wizardClass}
                actions={actions}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                immSteps={steps}
                showPreLeaveModal={true}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButton={true}
                    nextButtonDisabled={nextButtonDisabledStep1}
                >
                    <ChangeSecurityKitStep
                        isNerudaUser={isNerudaUser}
                        ref={this.setNode}
                        defaultKit={defaultKit}
                        referencePillButton={referencePillButton}
                        referenceKits={referenceKits}
                        sets={sets}
                        setButtonDisabled={(value) => this.setState({ nextButtonDisabledStep1: value})}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    finishButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton={immFinalButton}
                >
                    <h3 className="my-profile-security-kit-change__title-kits-summary print-title" >
                        <FormattedText value="cardGenericConfirmationStep-title" />
                    </h3>
                    <KitsSummary
                        sets={sets}
                        referenceKits={referenceKits}
                    />
                    <SignaturePattern
                        operationType={SECURITY_KIT_CHANGE}
                        operationParams={{}}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    render () {
        return (
            <div className="my-profile-security-kit-change" >
                { this.renderWizard() }
            </div>
        )
    }
}

MyProfileSecurityKitChange.propTypes = {
    immMyProfileSecurityKitChange: PropTypes.object.isRequired,
    isNerudaUser: PropTypes.bool.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    changeKit: PropTypes.func.isRequired,
    validateAndExecuteSagas: PropTypes.func.isRequired
};

const mapDispatchToProps = {
    changeKit,
    validateAndExecuteSagas
}

module.exports.MyProfileSecurityKitChange = connect(
    null,
    mapDispatchToProps
)(MyProfileSecurityKitChange);
